const STORAGE_KEY = "__academetrics";
const SHARED_FILTERS_KEY = "__academetrics_shared_filters";
const DATE_RANGE_KEY = "__academetrics_date_range";

export const getStoredState = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

export const updateStoredState = (updates) => {
  try {
    const currentState = getStoredState();

    const newState = { ...currentState, ...updates };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
  } catch (error) {
    console.log("@error", error);
  }
};

// Funções para filtros compartilhados entre Finance e Acadêmico
export const saveSharedFilters = (filters) => {
  try {
    const filterData = {
      ...filters,
      savedAt: new Date().toISOString(),
      source: filters.source || "Financeiro"
    };
    localStorage.setItem(SHARED_FILTERS_KEY, JSON.stringify(filterData));
  } catch (error) {
    console.log("@error saving shared filters", error);
  }
};

export const getSharedFilters = () => {
  try {
    const stored = localStorage.getItem(SHARED_FILTERS_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.log("@error getting shared filters", error);
    return null;
  }
};

export const clearSharedFilters = () => {
  try {
    localStorage.removeItem(SHARED_FILTERS_KEY);
  } catch (error) {
    console.log("@error clearing shared filters", error);
  }
};

// Funções para persistir o filtro de data entre todas as telas
export const saveDateRange = (dateRange) => {
  try {
    const data = {
      from: dateRange?.from ? dateRange.from.toISOString() : null,
      to: dateRange?.to ? dateRange.to.toISOString() : null
    };
    localStorage.setItem(DATE_RANGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.log("@error saving date range", error);
  }
};

export const getDateRange = () => {
  try {
    const stored = localStorage.getItem(DATE_RANGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return {
      from: parsed.from ? new Date(parsed.from) : null,
      to: parsed.to ? new Date(parsed.to) : null
    };
  } catch (error) {
    console.log("@error getting date range", error);
    return null;
  }
};

export const clearDateRange = () => {
  try {
    localStorage.removeItem(DATE_RANGE_KEY);
  } catch (error) {
    console.log("@error clearing date range", error);
  }
};
